import clsx from 'clsx'

export const PageTitle = ({ title, className }: { title: string; className?: string }) => {
  return <h1 className={clsx('text-[28px] md:text-3xl leading-[40px]', className)}>{title}</h1>
}
